import { render, staticRenderFns } from "./DocumentSeriesFilters.vue?vue&type=template&id=d2e5b048&"
import script from "./DocumentSeriesFilters.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports